export default {
  cards: {
    table: {
      detail: {
        content: {
          title: "Detail Data",
          showTitle: true,
          subtitle: "Detail Data Tahun 2020",
          showSubtitle: true,
          showIcon: false,
          info: "#### Menunjukan detail data pada tahun 2020",
          showInfo: true,
          showSaveAsImage: false,
          showTable: false,
          showDownloadTable: true,
        },
        options: {
          columns: [
            {
              title: "Provinsi",
              dataIndex: "provinsi",
              sorter: (a, b) => a.provinsi.localeCompare(b.provinsi),
            },
            {
              title: "Nilai Indeks",
              dataIndex: "indeks_karakter",
              sorter: (a, b) => a.indeks_karakter - b.indeks_karakter,
            },
            {
              title: "Jumlah Kab / Kota",
              dataIndex: "jumlah_kab",
              sorter: (a, b) => a.jumlah_kab - b.jumlah_kab,
              render: (e) => e ?? "-",
            },
            {
              title: "Jumlah Sekolah",
              dataIndex: "jumlah_sekolah",
              sorter: (a, b) => a.jumlah_sekolah - b.jumlah_sekolah,
              render: (e) => e ?? "-",
            },
            {
              title: "Target Responden",
              dataIndex: "target_responden",
              sorter: (a, b) => a.target_responden - b.target_responden,
              render: (e) => e ?? "-",
            },
            {
              title: "Responden Riil",
              dataIndex: "riil_responden",
              sorter: (a, b) => a.riil_responden - b.riil_responden,
              render: (e) => e ?? "-",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
